<template>
  <div class="validation-error-messages">
    <div
      v-for="(errorMessage, index) in errorMessageList"
      :key="index"
      class="error-message"
    >
      <!-- サーバのバリデーションメッセージ。入力値がそのまま含まれることがあるため v-html は使わない -->
      <div>{{ errorMessage }}</div>
    </div>
    <!--
      重複しているデータの一覧（例: どのプログラムと重複しているか）。
      リンクと同じ理由で、本文に混ぜずにサーバから受け取り、ここで <a> として組み立てる。
      表示する名前はユーザーの入力値なので、必ずテキストとして描画する。
    -->
    <div v-if="duplicateData" class="error-message">
      <div>{{ duplicateData.title }}</div>
      <div v-for="(duplicateItemData, index) in duplicateData.list" :key="index">
        <a :href="duplicateItemData.url" target="_blank" rel="noopener noreferrer">{{
          duplicateItemData.linkText
        }}</a>
      </div>
    </div>
    <!--
      マニュアル等へのリンク。
      本文に <a> を混ぜるとタグが文字として表示されてしまうため、
      サーバからは本文と分けて受け取り、ここで <a> として組み立てる。
    -->
    <div v-if="linkData" class="error-message">
      {{ linkData.prefix
      }}<a :href="linkData.url" target="_blank" rel="noopener noreferrer">{{
        linkData.linkText
      }}</a
      >{{ linkData.suffix }}
    </div>
  </div>
</template>

<script>
export default {
  name: "validation-error-messages",
  props: {
    errorMessageList: Array,
    // { prefix, linkText, suffix, url } 形式。 リンクを出さない場合は未指定でよい
    linkData: {
      type: Object,
      default: null,
    },
    // { title, list: [{ url, linkText }] } 形式。 一覧を出さない場合は未指定でよい
    duplicateData: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.error-message {
  font-size: 12px;
  color: red;
}
</style>
